import { Modelo } from '@ext/index';
import * as Types from './Etiquetadora.types';
import moment, { Moment } from 'moment';

export class IEtiquetadora extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number = 0;
    public Nombre: string = '';


    public getJson(): any
    {
        let json: any = {};

        json.id = this.Id;
        json.nombre = this.Nombre;


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Nombre = !this.Json.nombre ? '' : this.Json.nombre;


        this.Existe = true;
        return this.Existe;
    }


}
